import { InjectionToken, Type } from '@angular/core';

export const APP_NAVBAR_LOGO_COMPONENT = new InjectionToken<Type<unknown>>(
  'APP_NAVBAR_LOGO_COMPONENT'
);

/** Layout for the account flow header logo (icon id + dimensions). Provided per app variant in libs/apps. */
export interface AccountLogoLayoutConfig {
  iconName: string;
  iconHeight: number;
  iconWidth: number | null;
}

/** Used when no variant registers {@link APP_ACCOUNT_LOGO_LAYOUT} (e.g. shells without accounts branding). */
export const DEFAULT_ACCOUNT_LOGO_LAYOUT: AccountLogoLayoutConfig = {
  iconName: 'actuar-logo',
  iconHeight: 28,
  iconWidth: 123,
};

export const APP_ACCOUNT_LOGO_LAYOUT = new InjectionToken<AccountLogoLayoutConfig>(
  'APP_ACCOUNT_LOGO_LAYOUT'
);

/**
 * Opt-in flag for the native biometric-login feature (fingerprint / Face ID unlock).
 * Only apps that provide this (via `AppConfigOptions.biometricLogin`) enroll biometrics
 * after login and show the `/login/biometrics` gate. Absent → the feature stays dormant,
 * so web apps and native apps that have not opted in behave exactly as before.
 */
export const APP_BIOMETRIC_LOGIN = new InjectionToken<boolean>('APP_BIOMETRIC_LOGIN');

